import { createVuetify } from 'vuetify';

import { VDateInput } from 'vuetify/labs/VDateInput';

import { vuetifyOptions } from '@qsrsoft/myq-core';

const vuetifyComponents = {
  ...(vuetifyOptions.components ?? {}),
  VDateInput,
};

export const vuetify = createVuetify({
  ...vuetifyOptions,
  components: vuetifyComponents,
});
